import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormArray,
  ReactiveFormsModule,
  FormsModule,
  Validators
} from '@angular/forms';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import {
  DataService,
  UserService,
  OperationsService,
  AuthenticationService,
  StorageService
} from '../_services/index';
import { Transaction } from './transaction.interface';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-transactionform',
  templateUrl: './transactionform.component.html',
  styleUrls: ['./transactionform.component.css']
})
export class TransactionformComponent implements OnInit {
  @Input('com_accounts') com_accounts: any;
  @Input('people_customers') people_customers: any;
  @Input('currentUser') currentUser: any;
  loans: any;
  investments: any;
  transaction: Transaction;
  @Input('issearching') issearching = false;
  @Input('use_as_sub') use_as_sub: boolean;
  @Input('use_as_date') use_as_date: boolean;
  @Output() doTheTransfer = new EventEmitter();
  @Output() editRecord = new EventEmitter();
  errors = {
    DATE_ADDED: false,
    IFN: false,
    ACCOUNT_ID: false,
    OTHER_FORM_TYPE: false,
    LOANS: false,
    INVESTMENTS: false,
    NARRATION: false,
    ISA: false,
    CREDIT: false,
    DEBIT: false
  };
  journal: any = {
    journal_id: '',
    batch_id: '',
    journal_date: '',
    narration: ''
  };
  journal_view: any = 'company';
  search_name: string;
  customers_with_booked_loans: any;
  customer_loans: any;
  customer_loan_id: any;
  account_name: any;
  account_id: any;
  GL_ACCOUNT_ID: any;
  legal_name: any;
  credit_list: any;
  debit_list: any;
  constructor(
    public operationsService: OperationsService,
    public dataService: DataService,
    private http: HttpClient,
    private storageService: StorageService,
    private toastr: ToastrService
  ) {
    this.dataService.onEditCredit.subscribe(res => {
      this.transaction = res.credit;
    });
    this.dataService.onEditDebit.subscribe(res => {
      this.transaction = res.debit;
    });
  }

  ngOnInit() {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.debit_list = [];
    this.credit_list = [];
    this.transaction = {
      DATE_ADDED: '',
      IFN: '',
      ACCOUNT_ID: '',
      OTHER_FORM_TYPE: '0',
      LOANS: '',
      INVESTMENTS: '',
      NARRATION: '',
      ISA: '0',
      TTYPE: '',
      LOAN_ID: '',
      CREDIT: '',
      DEBIT: ''
    };
    this.displayAccounts();
  }
  showError(msg) {
    return this.toastr.error(msg, 'Error');
  }
  save(formvalue, isvalid) {
    this.transaction.ACCOUNT_NAME = this.account_name || this.legal_name;
    this.transaction.ACCOUNT_ID = this.account_id || this.GL_ACCOUNT_ID;
    this.transaction.LOAN_ID = this.customer_loan_id;
    // this.transaction.ACCOUNT_ID = this.GL_ACCOUNT_ID;
    this.errors = {
      DATE_ADDED: false,
      IFN: false,
      ACCOUNT_ID: false,
      OTHER_FORM_TYPE: false,
      LOANS: false,
      INVESTMENTS: false,
      NARRATION: false,
      ISA: false,
      DEBIT: false,
      CREDIT: false
    };
    if (this.transaction.ACCOUNT_ID == '') {
      this.errors.ACCOUNT_ID = true;
      return this.showError('Select an account');
    }

    if (this.transaction.IFN == '') {
      this.errors.IFN = true;
      return this.showError('IFN is required');
    }

    if (this.transaction.ISA == '1') {
      if (this.transaction.OTHER_FORM_TYPE == '0') {
        this.errors.OTHER_FORM_TYPE = true;

        return;
      }
    }
    if (this.transaction.ISA == '1') {
      if (this.transaction.OTHER_FORM_TYPE == '1') {
        if (this.transaction.LOANS == '') {
          this.errors.LOANS = true;

          return;
        }
      }
      if (this.transaction.OTHER_FORM_TYPE == '2') {
        if (this.transaction.INVESTMENTS == '') {
          this.errors.INVESTMENTS = true;

          return;
        }
      }
    }
    if (this.transaction.DEBIT == '0' && this.transaction.CREDIT == '0') {
      this.errors.DEBIT = true;
      this.errors.CREDIT = true;
      return this.showError('Transaction amount cannot be 0');
    }
    if (this.transaction.CREDIT == '' && this.transaction.DEBIT == '') {
      this.errors.DEBIT = true;
      this.errors.CREDIT = true;
      return this.showError('Enter transaction amount');
    }
    if (this.transaction.DATE_ADDED == '') {
      this.errors.DATE_ADDED = true;

      return this.showError('Select date fo the transaction');
    }
    // let savedJournals;

    if (localStorage.getItem('credit_transactions') || localStorage.getItem('debit_transactions') == null) {
      // savedJournals = [];

    } else {
      // savedJournals = JSON.parse(localStorage.getItem("saved_journals"));
      this.credit_list = JSON.parse(localStorage.getItem('credit_transactions'));
      this.debit_list = JSON.parse(localStorage.getItem('debit_transactions'));
      console.log(this.credit_list, this.debit_list);
    }
    if (this.transaction.DEBIT != 0) {
      this.transaction.TTYPE = 1;
      console.log(this.debit_list);
      this.debit_list.push(this.transaction);
    }
    if (this.transaction.CREDIT != 0) {
      this.transaction.TTYPE = 2;
      console.log(this.credit_list);
      this.credit_list.push(this.transaction);
    }
    localStorage.setItem('debit_transactions', JSON.stringify(this.debit_list));
    localStorage.setItem('credit_transactions', JSON.stringify(this.credit_list));
    // savedJournals.push(this.transaction);
    // localStorage.setItem("saved_journals", JSON.stringify(savedJournals));
    this.dataService.emitJournals.emit({credit: this.credit_list, debit: this.debit_list});
    this.doTheTransfer.emit(this.transaction);
    this.transaction = {
      DATE_ADDED: '',
      IFN: '',
      ACCOUNT_ID: '',
      OTHER_FORM_TYPE: '0',
      LOANS: '',
      INVESTMENTS: '',
      NARRATION: '',
      ISA: '0',
      TTYPE: '',
      LOAN_ID: '',
      ACCOUNT_NAME: '',
      DEBIT: '',
      CREDIT: ''
    };
  }

  changeOtherFormType(event) {
    this.operationsService
      .getRecords(
        this.currentUser.token,
        this.transaction.ACCOUNT_ID.PEOPLE_CUSTOMERS_ID,
        event
      )
      .subscribe(options => {
        if (event == '1') {
          this.loans = options;
        }
        if (event == '2') {
          this.investments = options;
        }
      });
  }
  changeAccountType(event) {
    this.account_name = event.account_name;
    this.account_id = event.id;
    if (event.ACCOUNT_ID) {
      this.transaction.ISA = '2';
    }
    if (event.PEOPLE_CUSTOMERS_ID) {
      this.transaction.ISA = '1';
    }
  }
  displayAccounts() {
    return this.operationsService.displayAccounts(this.currentUser.token)
      .subscribe(res => {
        this.com_accounts = res.all_accounts;
      });
  }
  changeView(e) {
    this.journal_view = e.target.value;
    this.dataService.changeJournalView.emit();
    this.transaction = {
      DATE_ADDED: '',
      IFN: '',
      ACCOUNT_ID: '',
      OTHER_FORM_TYPE: '0',
      LOANS: '',
      INVESTMENTS: '',
      NARRATION: '',
      ISA: '0',
      TTYPE: '',
      LOAN_ID: '',
      CREDIT: '',
      DEBIT: ''
    };
  }
  searchForCustomer() {
    const searchName = this.search_name;
    return this.operationsService
      .searchForCustomer(this.currentUser.token, searchName)
      .subscribe(res => {
        this.customers_with_booked_loans = res.people_with_booked_loans;
      });
  }
  selectCustomer(event) {
    const customer_id = event.PEOPLE_ID;
    this.GL_ACCOUNT_ID = event.GL_ACCOUNT_ID;
    this.legal_name = event.LEGAL_NAME;
    return this.operationsService
      .selectCustomer(this.currentUser.token, customer_id)
      .subscribe(res => {
        this.customer_loans = res.customer_loans;
      });
  }
}
